// app/javascript/controllers/swiper_controller.js
import { Controller } from "@hotwired/stimulus";
import Swiper from "swiper/bundle";

// https://pagedone.io/docs/carousel
export default class extends Controller {
  connect() {
    this.swiper = new Swiper(".progress-slide-carousel", {
        loop: true,
        fraction: true,
        effect: "fade",
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".progress-slide-carousel .swiper-pagination",
            type: "bullets",
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        }
    })
  }
}